export default {
  'pendingDecisionsForm.ruleChange': 'Rule Change',
  'pendingDecisionsForm.viewAppliedRule': 'View Applied Rule',
  'pendingDecisionsForm.modifyAppliedRule': 'Modify Applied Rule',
  'pendingDecisionsForm.addPaymentRule': 'Add Payment rule',
  'pendingDecisionsForm.payAndAddRuleSuccessMsg':
    'Decision "Pay" is applied and new payment rule is created.',
  'pendingDecisionsForm.returnAndAddRuleSuccessMsg':
    'Decision "Return" is applied and new payment rule is created.',
  'pendingDecisionsForm.dualControl.payAndAddRuleSuccessMsg':
    'Decision "Pay" is applied and rule has been submitted for approval.',
  'pendingDecisionsForm.dualControl.returnAndAddRuleSuccessMsg':
    'Decision "Return" is applied and rule has been submitted for approval.',
  'pendingDecisionsForm.amountLessThen': 'Amount cannot be less than <%= min %>',
  'pendingDecisionsForm.amountGreaterThen': 'Amount cannot be greater than <%= min %>'
};
